import ReactSelect, { Props as ReactSelectProps, components } from 'react-select';

import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

import styles from './custom-react-select.module.css';

export type CustomReactSelectOptions = {
  wrapperClass?: string;
  clearAllClass?: string;
  disableClearWhenNotFocused?: boolean;
  label?: string;
  // react select props are funky, need to type as any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?: React.RefObject<any>;
};

const Menu = components.Menu;

const CustomReactSelect = ({
  clearAllClass,
  disableClearWhenNotFocused,
  wrapperClass,
  label,
  ref,
  ...rest
}: ReactSelectProps & CustomReactSelectOptions) => {
  return (
    <div className={`${styles['custom-react-select-wrapper']} ${wrapperClass || ''}`}>
      {rest?.isSearchable && (
        <div
          data-testid="custom-react-select-search-icon-wrapper"
          className={styles['custom-react-select-search-icon-wrapper']}
        >
          <Icon name={ICONS.SEARCH} />
        </div>
      )}

      {label && <label className="L2">{label}</label>}
      <ReactSelect
        {...rest}
        ref={ref}
        components={{
          ...rest?.components,
          Menu:
            rest?.components?.Menu ||
            ((props) => (
              <div className="react-select-menu-container">
                <Menu {...props} />
              </div>
            )),
          ClearIndicator:
            rest?.components?.ClearIndicator ||
            ((props) => (
              <div
                {...props.innerProps}
                className={`${clearAllClass || ''} ${props.innerProps.className}`}
                style={{ ...props.innerProps.style, display: 'flex' }}
                tabIndex={0}
                onMouseDown={(e) => {
                  if (disableClearWhenNotFocused && !props.isFocused) {
                    return;
                  }
                  props?.innerProps?.onMouseDown?.(e);
                }}
                onTouchEnd={(e) => {
                  if (disableClearWhenNotFocused && !props.isFocused) {
                    return;
                  }
                  props?.innerProps?.onTouchEnd?.(e);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    props.clearValue();
                    // refocus the input after clearing the value
                    const inputRef = ref?.current?.inputRef;
                    if (inputRef) {
                      inputRef.focus();
                    }
                  }
                }}
              >
                <Icon name={ICONS.CLOSE} size={14} />
              </div>
            )),
        }}
      />
    </div>
  );
};

export default CustomReactSelect;
